import { Box, Chip } from '@mui/material';
import DriverProfile from '../DriverProfile';
import { DriverDtoModelType } from '../../../store/mst/models';
import { DriverChipStyles } from './Styles/Default';

interface Props {
  driver: DriverDtoModelType;
  onDelete: () => void;
}

const DriverChip: React.FC<Props> = ({ driver, onDelete }) => (
  <Chip
    data-testid={`driver-filter-chip-${driver.id}`}
    sx={DriverChipStyles}
    onDelete={onDelete}
    label={
      <Box sx={{ paddingLeft: '0px' }} >
        <DriverProfile driverName={driver.name} avatarSize="small" deleted={driver.deleted ?? false} />
      </Box>
    }
  />
);

export default DriverChip;
